import React from 'react';

import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

import { Skeleton } from '../../../../atoms/Skeleton';

const useStyles = makeStyles((theme: Theme) => ({
  imageContainerSkeleton: {
    borderRadius: '72px 0px 0px 72px',
    display: 'flex',
    height: '144px',
    justifyContent: 'center',
    margin: theme.spacing(1, 0, 6, 2),
    overflow: 'hidden',
  },
  orderStatusSkeleton: {
    padding: theme.spacing(0, 2),
  },
  [theme.breakpoints.up('sm')]: {
    orderStatusSkeleton: {
      padding: theme.spacing(0, 3),
    },
  },
  [theme.breakpoints.up('md')]: {
    orderStatusSkeleton: {
      padding: theme.spacing(0),
    },
  },
  progressBarSkeleton: {
    margin: theme.spacing(1.5, 0, 1.5, 0),
    height: '8px',
  },
  statusDescriptionSkeleton: {
    paddingTop: theme.spacing(0.5),
    fontSize: '13px',
    width: '50%',
  },
  statusNameSkeleton: {
    width: '80%',
    fontSize: '28px',
  },
}));

export function OrderStatusSkeleton(): JSX.Element {
  const classes = useStyles();
  return (
    <div
      className="fd-order-status-loading-skeleton"
      data-fd="order-status-skeleton"
    >
      <div className={classes.orderStatusSkeleton}>
        <Skeleton
          className={classes.statusNameSkeleton}
          dataFd="status-name-skeleton"
        />
        <Skeleton
          className={classes.statusDescriptionSkeleton}
          dataFd="status-description-skeleton"
        />
        <Skeleton
          className={classes.progressBarSkeleton}
          dataFd="status-bar-skeleton"
          variant="rect"
        />
      </div>
      <Skeleton
        className={classes.imageContainerSkeleton}
        dataFd="status-image-skeleton"
        variant="rect"
      />
    </div>
  );
}
